<template>
  <v-dialog
      v-model="item.active"
      persistent
      max-width="500"
      @input="(v) => v || disagree"
  >
    <v-card>
      <v-card-title class="headline">
        {{ item.title }}
      </v-card-title>
      <v-card-text>{{ item.content }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            depressed
            @click="disagree"
        >
          キャンセル
        </v-btn>
        <v-btn
            depressed
            color="error"
            @click="agree"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {store} from "@/store";

export default {
  name: "ConfirmDialog",
  data() {
    return {
      item: store.state.confirmDialog,
    }
  },
  methods: {
    agree() {
      store.agreeConfirmDialog();
    },
    disagree() {
      store.disagreeConfirmDialog();
    }
  }
}
</script>
